"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.mainPageProviderSaga = exports.setTopEventSseSaga = exports.fetchMainPageEventsSuccessSaga = void 0;
const headers_1 = require("astra-core/utils/api/headers");
const effects_1 = require("redux-saga/effects");
const slice_1 = require("astra-core/containers/EventsProvider/slice");
const saga_1 = require("astra-core/containers/ConfigProvider/saga");
const saga_2 = require("astra-core/containers/EventsProvider/saga");
const saga_3 = require("astra-core/containers/AccountProvider/saga");
const types_1 = require("astra-core/utils/api/types");
const CommonDataProvider_1 = require("astra-core/containers/CommonDataProvider");
const events_1 = require("astra-core/utils/events");
const types_2 = require("astra-core/containers/ConfigProvider/types");
const selectors_1 = require("astra-core/containers/EventsProvider/selectors");
const constants_1 = require("astra-core/containers/BasketProvider/constants");
const errors_1 = require("../../shared/errors");
const slice_2 = require("./slice");
const utils_1 = require("./utils");
const types_3 = require("./types");
function* fetchMainPageEventsSuccessSaga(action) {
    const { events, eventsType } = action.payload;
    const sports = yield (0, effects_1.select)(CommonDataProvider_1.selectSports);
    const payload = (0, utils_1.groupTopEvents)(events, sports);
    switch (eventsType) {
        case types_3.EventType.TOP_LIVE:
            yield (0, effects_1.put)(slice_2.mainPageProviderActions.fetchTopLiveEventsSuccess(Object.assign(Object.assign({}, payload), { reqData: action.payload.reqData, responseInfo: action.payload.responseInfo })));
            return;
        case types_3.EventType.TOP_LINE:
            yield (0, effects_1.put)(slice_2.mainPageProviderActions.fetchTopLineEventsSuccess(Object.assign(Object.assign({}, payload), { reqData: action.payload.reqData, responseInfo: action.payload.responseInfo })));
            return;
    }
}
exports.fetchMainPageEventsSuccessSaga = fetchMainPageEventsSuccessSaga;
function* handleFetchTopLiveEvents() {
    const cursor = yield (0, effects_1.select)(selectors_1.selectTopEventCursorSSE);
    const reqData = yield (0, effects_1.call)(utils_1.buildGetEventsRequest, {
        live: true,
        withCursor: cursor ? undefined : true,
    });
    yield (0, effects_1.put)(slice_1.eventsProviderActions.fetchEvents({
        reqData,
        sideEffects: {
            onSuccess({ resData, reqData, responseInfo }) {
                return slice_2.mainPageProviderActions.fetchMainPageEventsSuccess({
                    events: resData.items,
                    eventsType: types_3.EventType.TOP_LIVE,
                    reqData,
                    responseInfo,
                });
            },
            onError(errorData) {
                return slice_2.mainPageProviderActions.fetchTopLiveEventsError(errorData);
            },
        },
    }));
}
function* handleFetchTopLineEvents() {
    const cursor = yield (0, effects_1.select)(selectors_1.selectTopEventCursorSSE);
    const reqData = yield (0, effects_1.call)(utils_1.buildGetEventsRequest, {
        live: false,
        withCursor: cursor ? undefined : true,
    });
    yield (0, effects_1.put)(slice_1.eventsProviderActions.fetchEvents({
        reqData,
        sideEffects: {
            onSuccess({ resData, reqData, responseInfo }) {
                return slice_2.mainPageProviderActions.fetchMainPageEventsSuccess({
                    events: resData.items,
                    eventsType: types_3.EventType.TOP_LINE,
                    reqData,
                    responseInfo,
                });
            },
            onError(errorData) {
                return slice_2.mainPageProviderActions.fetchTopLineEventsError(errorData);
            },
        },
    }));
}
function* setTopEventSseSaga({ payload: { event }, }) {
    const isEntityTagsEnabled = yield (0, effects_1.call)(saga_1.isFeatureFlagEnabledSaga, types_2.EFeatureFlags.ENTITY_TAGS_ENABLED);
    const { top, live } = event;
    const topTagId = yield (0, effects_1.select)(CommonDataProvider_1.selectTopTagId);
    const isTopEvent = isEntityTagsEnabled ? (0, events_1.isTopEntity)(event, topTagId) : top;
    const sport = yield (0, effects_1.select)(CommonDataProvider_1.selectSport, event.tournament.sportId);
    const payload = { event, sport };
    try {
        if (constants_1.endedEventStatus.includes(event.status)) {
            yield (0, effects_1.put)(slice_2.mainPageProviderActions.removeTopLiveEventsSSE(payload));
            yield (0, effects_1.put)(slice_2.mainPageProviderActions.removeTopLineEventsSSE(payload));
            yield (0, effects_1.put)(slice_1.eventsProviderActions.clearEvent({ eventId: event.id }));
        }
        else if (isTopEvent) {
            if (live) {
                yield (0, effects_1.put)(slice_2.mainPageProviderActions.setTopLiveEventsSSE(payload));
                yield (0, effects_1.put)(slice_2.mainPageProviderActions.removeTopLineEventsSSE(payload));
            }
            else {
                yield (0, effects_1.put)(slice_2.mainPageProviderActions.setTopLineEventsSSE(payload));
                yield (0, effects_1.put)(slice_2.mainPageProviderActions.removeTopLiveEventsSSE(payload));
            }
        }
        else {
            yield (0, effects_1.put)(slice_2.mainPageProviderActions.removeTopLiveEventsSSE(payload));
            yield (0, effects_1.put)(slice_2.mainPageProviderActions.removeTopLineEventsSSE(payload));
        }
    }
    catch (e) {
        const error = (0, errors_1.getErrorOrUnknown)(e);
        console.error('setTopEventSseSaga error', error);
    }
}
exports.setTopEventSseSaga = setTopEventSseSaga;
function* resubscribeSseMainPageSaga() {
    try {
        yield (0, effects_1.put)(slice_1.eventsProviderActions.resubscribeEventProbabilitiesSSE());
        yield (0, effects_1.put)(slice_1.eventsProviderActions.resubscribeTopEventsSSE({}));
    }
    catch (e) {
        const error = (0, errors_1.getErrorOrUnknown)(e);
        console.error('resubscribeSseMainPage error', error);
    }
}
function* fetchInitDataSaga() {
    try {
        yield (0, effects_1.put)(slice_1.eventsProviderActions.setTopEventsSSEStatus({
            type: types_1.EEventMessageSSEType.PENDING,
        }));
        yield (0, effects_1.call)(fetchInitTopEvents);
        yield (0, effects_1.put)(slice_1.eventsProviderActions.subscribeTopEventsSSE({}));
        const accountId = yield (0, effects_1.call)(saga_3.getAccountId);
        if (accountId) {
            yield (0, effects_1.put)(slice_2.mainPageProviderActions.resubscribeSseMainPage());
        }
    }
    catch (e) {
        const error = (0, errors_1.getErrorOrUnknown)(e);
        console.error('error fetchInitDataSaga', error);
    }
}
function* fetchInitTopEvents() {
    try {
        yield (0, effects_1.put)(slice_2.mainPageProviderActions.fetchTopLineEvents());
        // we fetch top live separately because we should use 'call' for blocking effect
        // So we need to put loading status manually
        yield (0, effects_1.put)(slice_2.mainPageProviderActions.setIsLiveEventsLoading(true));
        const sports = yield (0, effects_1.select)(CommonDataProvider_1.selectSports);
        const cursor = yield (0, effects_1.select)(selectors_1.selectTopEventCursorSSE);
        const reqData = yield (0, effects_1.call)(utils_1.buildGetEventsRequest, {
            live: true,
            withCursor: cursor ? undefined : true,
        });
        yield (0, effects_1.call)(saga_2.fetchEventsSaga, {
            payload: {
                reqData,
                sideEffects: {
                    onSuccess({ resData, reqData, responseInfo }) {
                        const payload = (0, utils_1.groupTopEvents)(resData.items, sports);
                        return slice_2.mainPageProviderActions.fetchTopLiveEventsSuccess(Object.assign(Object.assign({}, payload), { reqData,
                            responseInfo }));
                    },
                    onError(errorData) {
                        return slice_2.mainPageProviderActions.fetchTopLiveEventsError(errorData);
                    },
                },
            },
            type: slice_1.eventsProviderActions.fetchEvents.type,
        });
    }
    catch (e) {
        const error = (0, errors_1.getErrorOrUnknown)(e);
        console.error('error fetchInitTopEvents', error);
    }
}
function* setCursorTopEventsSaga(action) {
    var _a, _b;
    if (action.payload.reqData.withCursor) {
        const headers = (_b = (_a = action.payload.responseInfo) === null || _a === void 0 ? void 0 : _a.headers) !== null && _b !== void 0 ? _b : null;
        const newCursor = (0, headers_1.getHeadersFetch)(headers, 'x-cursor', false);
        yield (0, effects_1.put)(slice_1.eventsProviderActions.setCursorTopEvents({ cursor: newCursor }));
    }
}
function* mainPageProviderSaga() {
    yield (0, effects_1.all)([
        (0, effects_1.takeLatest)(slice_2.mainPageProviderActions.fetchTopLiveEvents, handleFetchTopLiveEvents),
        (0, effects_1.takeLatest)(slice_2.mainPageProviderActions.fetchTopLineEvents, handleFetchTopLineEvents),
        (0, effects_1.takeEvery)(slice_2.mainPageProviderActions.fetchMainPageEventsSuccess, fetchMainPageEventsSuccessSaga),
        (0, effects_1.takeLatest)(slice_2.mainPageProviderActions.fetchInitData, fetchInitDataSaga),
        (0, effects_1.takeLatest)(slice_2.mainPageProviderActions.resubscribeSseMainPage, resubscribeSseMainPageSaga),
        (0, effects_1.takeLatest)(slice_1.eventsProviderActions.eventChangedBySse, setTopEventSseSaga),
        (0, effects_1.takeLatest)(slice_2.mainPageProviderActions.fetchMainPageEventsSuccess, setCursorTopEventsSaga),
        (0, effects_1.takeLatest)(slice_2.mainPageProviderActions.fetchTopLiveEventsSuccess, setCursorTopEventsSaga),
    ]);
}
exports.mainPageProviderSaga = mainPageProviderSaga;
//# sourceMappingURL=saga.js.map